
import PolicyList from './List';
import PolicyForm from './Form';

export default {
    path: 'cadastros',
    redirect: '/cadastros/clientes',
    name: 'Cadastro Apólices',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            // LISTAR TODAS AS APOLICES
            path: 'apolices',
            name: 'list-policies',
            component: PolicyList,
            meta: {
                requiresAuth: true,
                label: 'Listar Apólices'
            }
        },
        {
            // LISTAR  APOLICES DO CLIENTE
            path: 'clientes/:id/apolices/:idPolicy',
            name: 'edit-policies',
            component: PolicyList,
            meta: {
                requiresAuth: true,
                label: 'Listar Apólices'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/client/policy/router.js